import { ApiResponse } from 'apisauce'
import { call, put } from 'redux-saga/effects'

import api from 'src/services/api'

import { ClientNotifyCatch } from 'src/config/bugsnag'

import * as Actions from './actions'
import { ResponseOrganizations } from './types'

export function* getOrganizations() {
  try {
    const { data, ok }: ApiResponse<ResponseOrganizations> = yield call(
      api.get,
      `/organizations`
    )

    if (ok) {
      yield put(Actions.getOrganizationsSuccess(data.organizations))
      return
    }
    yield put(Actions.getOrganizationsFailure())
  } catch (err) {
    ClientNotifyCatch('Saga getOrganizations', err)
    yield put(Actions.getOrganizationsFailure())
  }
}
